require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-understanding-ux-design-front-end-development.json") })
        }
      }, "path---blog-understanding-ux-design-front-end-development");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-understanding-ux-design-front-end-development!./.cache/json/blog-understanding-ux-design-front-end-development.json
// module id = 1128
// module chunks = 231608221292675